import type { NavigateFunction } from 'react-router-dom'
import type { ComposerNavState } from '../pages/ComposerPage'
import type { PostIdea } from '../store/idea-store'

/**
 * Route a post to the post-aware Composer (the Studio for that Post) — the
 * shared target of the IdeaCard ••• → "Edit" action. Mirrors PostModal's
 * `handleEditPlatform`: opens on the first confirmed platform (falling back to
 * the primary) and seeds the composer's strip selection from the post's
 * platforms. Callers pass `source`/`entrySource` for analytics attribution.
 *
 * No-op for synthetic ideas — they wrap a standalone Creative with no Project
 * to open. Callers gate on `isSyntheticPostIdea` before showing Edit.
 */
export function editIdeaInComposer(
  navigate: NavigateFunction,
  idea: PostIdea,
  opts: { source: string; entrySource: ComposerNavState['entry_source'] }
): void {
  const platforms =
    idea.confirmedPlatforms && idea.confirmedPlatforms.length > 0
      ? idea.confirmedPlatforms
      : [idea.primaryPlatform]
  const navState: ComposerNavState = {
    activePlatforms: platforms,
    source: opts.source,
    entry_source: opts.entrySource,
  }
  // One Post model: editing lands on the POST view (the bare URL is the editor).
  navigate(`/compose/${idea.projectId}`, { state: navState })
}
